// The objects a user follows on their own, with nothing of React or of the texts: the fake gateway of the e2e uses
// them too.

/** What a page follows: the aggregate it shows. */
export interface FollowTarget {
  entityType: string;
  entityId: string;
}

/** What of an object reaches the bell (ADR-307): each change of its status, or every change. */
export type FollowLevel = "status" | "all";

/** An object followed, as the gateways answer it (`followedObjectDto` of the notifications contract). */
export interface FollowedObject extends FollowTarget {
  /** The number of a PO, an inbound, an order or a claim, the name of a linesheet. */
  reference: string;
  status: string;
  level: FollowLevel;
  followedAt: string;
}

export const sameObject = (a: FollowTarget, b: FollowTarget): boolean =>
  a.entityType === b.entityType && a.entityId === b.entityId;
